import { useParams } from "react-router-dom"


export const HallBind = ({ }) => {
    const { id } = useParams()
    return (
        <>{id}</>
    )
}